import React from "react";
import { Form, Input } from "antd";

import { prettyPrintJSONString } from "../../shared/util/antdForm";

const ScenarioViewer = Form.create()(({ row, form: { getFieldDecorator } }) => (
  <Form autoComplete="off" layout="vertical">
    <Form.Item label="Name">
      {getFieldDecorator("name", {
        initialValue: row.name,
      })(<Input type="text" readOnly />)}
    </Form.Item>

    <Form.Item label="Description">
      {getFieldDecorator("description", {
        initialValue: row.description,
      })(<Input.TextArea readOnly autoSize={{ minRows: 2, maxRows: 5 }} />)}
    </Form.Item>

    <Form.Item label="Definition">
      {getFieldDecorator("definition", {
        initialValue: prettyPrintJSONString(row.definition || "{}"),
      })(<Input.TextArea readOnly autoSize={{ minRows: 4, maxRows: 15 }} />)}
    </Form.Item>
  </Form>
));
export default ScenarioViewer;
